import { getBookingSummary } from "@/api/report";
import { accountInfoState, salonActiveState } from "@/components/state";
import { formatDateTime } from "@/utils";
import { Dayjs } from "dayjs";
import { useRecoilState } from "recoil";

export function useQueriesBookingSummary(dateRange: [Dayjs, Dayjs]) {
    const [salonActive] = useRecoilState(salonActiveState);
    const [currentAccount] = useRecoilState(accountInfoState);

    if(salonActive) {
        const queriesBookingSummarySalonActive = salonActive?.salonBranches?.map((branch) => ({
            requestMeta: getBookingSummary,
            requestData: {
                query: {
                    startDate: formatDateTime(dateRange[0]),
                    endDate: formatDateTime(dateRange[1]),
                    salonId: salonActive.id,
                    salonBranchId: branch.id
                }
            }
        }))

        return queriesBookingSummarySalonActive ?? [];
    }

    const queriesOverviewAllSalons = currentAccount?.salons?.map((salon) => {
        return {
            requestMeta: getBookingSummary,
            requestData: {
                query: {
                    startDate: formatDateTime(dateRange[0]),
                    endDate: formatDateTime(dateRange[1]),
                    salonId: salon.id
                }
            }
        }
    }).flat() ?? [];

    return queriesOverviewAllSalons;
}
